import { Component, OnChanges, SimpleChanges, Renderer2, Input, Output, EventEmitter, ChangeDetectionStrategy, AfterViewInit, ViewChild, ElementRef } from '@angular/core';

import * as State from '@shared/state';
import { IMenuFlowPage } from '@shared/state';

@Component({
    selector: 'shared-wizzard-sub-nav',
    templateUrl: './wizzard-sub-nav.shared.component.html',
    styleUrls: ['./wizzard-sub-nav.shared.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class WizzardSubNavComponent implements AfterViewInit, OnChanges {
    private _init: boolean = false;

    @Input() public activePageIdentifier: number = null;
    @Input() public menuFlowPages: IMenuFlowPage[] | State.IWizzardMenuFlowPage[];
    @Output() public onClick: EventEmitter<number> = new EventEmitter();
    @ViewChild('indicator', { static: true }) public indicator: ElementRef;
    @ViewChild('items', { static: true }) public items: ElementRef;

    constructor(
        public renderer2: Renderer2,
    ) { }

    ngOnChanges(changes: SimpleChanges): void {
        if (this._init) {
            if (changes.activePageIdentifier && this.activePageIdentifier) {
                this.setIndicator();
            }
        }
    }

    ngAfterViewInit(): void {
        this._init = true;
    }

    public setIndicator(): void {
        setTimeout(() => {
            /* Delay is required to handle boldness change and little size change */
            const items: HTMLUListElement = this.items ? this.items.nativeElement : null;
            const elem: HTMLLIElement = this.indicator ? this.indicator.nativeElement : null;

            if (!items || !elem) return;

            const activeLi: HTMLLIElement = items.querySelector(`#wizzard-sub-nav-${this.activePageIdentifier}`);
            if (!activeLi) return;

            const leftOffset: number = activeLi.offsetLeft;
            const width: number = activeLi.clientWidth;

            this.renderer2.setStyle(elem, 'transition', 'all .3s ease');
            this.renderer2.setStyle(elem, 'position', 'absolute');
            this.renderer2.setStyle(elem, 'bottom', '0');
            this.renderer2.setStyle(elem, 'left', `${leftOffset}px`);
            this.renderer2.setStyle(elem, 'width', `${width}px`);
        }, 10);
    }

    public onItemClick($event: Event, pageIdentifier: number): void {
        this.onClick.emit(pageIdentifier);
    }

    public trackBy(page: IMenuFlowPage | State.IWizzardMenuFlowPage, index: number): number {
        return page?.PageIdentifier || index;
    }
}
